import { Fragment } from 'react';

import { getAuthAccount, getAuthUser } from '@/shared/auth/selectors';
import { MenuItem } from '@/shared/components/nav/MenuItem';
import MenuItems from '@/shared/components/nav/MenuItems';
import ClockInMenuItem from '@/shared/components/nav/menu-items/ClockInMenuItem';
import { posthogCapture } from '@/shared/vendor/posthog';
import { useWiwSelector } from '@/store';

export default function AttendanceMenuItem() {
  const authAccount = useWiwSelector(getAuthAccount);
  const authUser = useWiwSelector(getAuthUser);
  const isSetup = authAccount.getSettings('payroll.is_onboarded', false) && authAccount.hasAttendance();

  function trackInteraction() {
    posthogCapture('top_nav.attendance');
  }

  // Only Admin and Managers can see nav item until completed
  if (!isSetup && (authUser.isEmployee() || authUser.isSupervisor())) {
    return null;
  }

  // If setup is not complete, send to the onboarding page
  if (!isSetup) {
    return (
      <MenuItem
        data-testid="top-nav-attendance"
        onClick={trackInteraction}
        className="upsell"
        icon="attendance"
        label="Attendance"
        hideLabel="tablet"
        show={true}
        to="/attendance/get-started"
      />
    );
  }

  return (
    <Fragment>
      <MenuItem icon="attendance" label="Attendance" hideLabel="tablet" className="dropdown-starts-left" dropdown>
        <MenuItems dropdownMenu>
          <MenuItem icon="timesheet" key="timesheets" label="Timesheets" show to="/timesheets" />

          {authUser.canSupervise() && (
            <MenuItem icon="tracker" key="timetracker" label="Time Tracker" show to="/attendance" />
          )}

          <ClockInMenuItem key="clock-in-menu" />

          {authUser.canSupervise() && <MenuItem icon="time-clock" label="Lock as Terminal" show to="/timeclock" />}
        </MenuItems>
      </MenuItem>
    </Fragment>
  );
}
